export default "<rm-dynamic-table \n[data]=\"items\" \n[columns]=\"columns\" \n[totalCount]=\"totalCount\"\n[pagination]=\"false\"></rm-dynamic-table>"